import {
    getFirmwareSchedules,
    getFirmwareSchedule,
    createFirmwareSchedule,
    updateFirmwareSchedule,
    deleteFirmwareSchedule,
    runFirmwareScheduleNow,
    getFirmwareScheduleRuns,
    checkFirmwareScheduleBaseOverlaps,
    resolveFirmwareScheduleBaseIds
} from '@/api/firmwareSchedules';

const firmwareSchedules = {
    namespaced: true,
    state: {
        list: { data: [], meta: {} },
        pageSize: 25,
        pageNumber: 1,
        filters: {},
        searchValue: '',
        loading: false
    },
    getters: {
        getList: state => state.list.data,
        getMeta: state => state.list.meta,
        getPageSize: state => state.pageSize,
        getPageNumber: state => state.pageNumber,
        isLoading: state => state.loading
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        },
        SET_PAGE_NUMBER(state, value) {
            state.pageNumber = value;
        },
        SET_PAGE_SIZE(state, value) {
            state.pageSize = value;
        },
        SET_FILTERS(state, value) {
            state.filters = value;
        },
        SET_SEARCH_VALUE(state, value) {
            state.searchValue = value;
        },
        SET_LOADING(state, value) {
            state.loading = value;
        }
    },
    actions: {
        Fetch({ commit, state }, params = {}) {
            commit('SET_LOADING', true);
            return new Promise((resolve, reject) => {
                getFirmwareSchedules({
                    page: params.page || state.pageNumber,
                    per_page: params.per_page || state.pageSize,
                    organization_id: params.organization_id !== undefined
                        ? params.organization_id
                        : state.filters.organization_id,
                    is_active: params.is_active !== undefined
                        ? params.is_active
                        : state.filters.is_active,
                    search: params.search !== undefined ? params.search : state.searchValue
                }).then(response => {
                    commit('SET_LIST', response);
                    if (response.meta && response.meta.current_page) {
                        commit('SET_PAGE_NUMBER', response.meta.current_page);
                    }
                    resolve(response);
                }).catch(reject).finally(() => commit('SET_LOADING', false));
            });
        },
        FetchOne(_, id) {
            return new Promise((resolve, reject) => {
                getFirmwareSchedule(id).then(resolve).catch(reject);
            });
        },
        Create(_, data) {
            return new Promise((resolve, reject) => {
                createFirmwareSchedule(data).then(resolve).catch(reject);
            });
        },
        Update(_, { id, data }) {
            return new Promise((resolve, reject) => {
                updateFirmwareSchedule(id, data).then(resolve).catch(reject);
            });
        },
        Delete(_, id) {
            return new Promise((resolve, reject) => {
                deleteFirmwareSchedule(id).then(resolve).catch(reject);
            });
        },
        RunNow(_, id) {
            return new Promise((resolve, reject) => {
                runFirmwareScheduleNow(id).then(resolve).catch(reject);
            });
        },
        FetchRuns(_, { id, params = {} }) {
            return new Promise((resolve, reject) => {
                getFirmwareScheduleRuns(id, params).then(resolve).catch(reject);
            });
        },
        CheckOverlaps(_, { baseIds, excludeScheduleId = null }) {
            return new Promise((resolve, reject) => {
                checkFirmwareScheduleBaseOverlaps(baseIds, excludeScheduleId)
                    .then(resolve).catch(reject);
            });
        },
        ResolveBaseIds(_, baseIds) {
            return new Promise((resolve, reject) => {
                resolveFirmwareScheduleBaseIds(baseIds)
                    .then(resolve).catch(reject);
            });
        }
    }
};

export default firmwareSchedules;
